import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useHoursPeriodSelector } from '../../../hooks/useHoursPeriodSelector';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const HoursPeriodSelectorWidget = () => {
    const { components } = useHoursPeriodSelector({
        validBetween: { from: { hour: 9, minute: 0 }, to: { hour: 17, minute: 0 } },
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [components.HoursPeriodSelector, _jsx(Typography, { variant: "h5", children: "fromPicker" }), _jsx(Stack, { direction: "row", children: components.fromPicker }), _jsx(Typography, { variant: "h5", children: "toPicker" }), _jsx(Stack, { direction: "row", children: components.toPicker }), _jsx(Typography, { variant: "h5", children: "validity" }), _jsx(Stack, { direction: "row", children: components.validity }), _jsx(Typography, { variant: "h5", children: "overnightWarning" }), _jsx(Stack, { direction: "row", children: components.overnightWarning })] })), [components]);
    return {
        name: 'useHoursPeriodSelector',
        category: 'hooks',
        component,
    };
};
